import tinycolor from 'tinycolor2';
import store from '../store';
import router from '../router';
import notificationAudio from '@/assets/sounds/notificationAudio.mp3';
export { removeAPIPrefix } from './url';
const getPrimaryLighter = (color) => {
    if (color === '#1A5276' || color === '#23761a') {
        return tinycolor(color).lighten(65).toString();
    }
    return tinycolor(color).lighten(45).toString();
};
export const setApplicationColors = (settings) => {
    const primaryLight = tinycolor(settings.primary_color).darken(1).toString();
    const primaryLighter = getPrimaryLighter(settings.primary_color);
    const primaryMedium = tinycolor(settings.primary_color).lighten(1).toString();
    const primaryDark = tinycolor(settings.primary_color).lighten(10).toString();
    const primaryDarker = tinycolor(settings.primary_color).darken(40).toString();
    const secondaryLight = tinycolor(settings.secondary_color).lighten(20).toString();
    const secondaryLighter = tinycolor(settings.secondary_color).lighten(40).toString();
    const secondaryDark = tinycolor(settings.secondary_color).lighten(10).toString();
    const secondaryDarker = tinycolor(settings.secondary_color).darken(40).toString();
    const root = document.documentElement;
    root.style.setProperty('--blue-0', settings.primary_color);
    root.style.setProperty('--blue-1', primaryDark);
    root.style.setProperty('--blue-2', primaryLight);
    root.style.setProperty('--blue-3', primaryDarker);
    root.style.setProperty('--blue-4', primaryLighter);
    root.style.setProperty('--blue-5', primaryMedium);
    root.style.setProperty('--orange-0', settings.secondary_color);
    root.style.setProperty('--orange-1', secondaryDark);
    root.style.setProperty('--orange-2', secondaryLight);
    root.style.setProperty('--orange-3', secondaryDarker);
    root.style.setProperty('--orange-4', secondaryLighter);
};
export const calcColorPickerPosition = (containerRelated, containerIdentifier) => {
    const wrapperDiv = document.querySelector(containerRelated);
    if (wrapperDiv) {
        const colorPickerCardSize = 350;
        const wrapperṔosition = wrapperDiv.getBoundingClientRect();
        let colorPickerPosition = {
            top: 0,
            left: 0
        };
        if (wrapperṔosition.right + colorPickerCardSize < window.innerWidth) {
            colorPickerPosition.left = wrapperṔosition.right + 10;
            colorPickerPosition.top = wrapperṔosition.top + window.scrollY;
        }
        else if (wrapperṔosition.left - colorPickerCardSize > 30) {
            colorPickerPosition.left = wrapperṔosition.left - 310;
            colorPickerPosition.top = wrapperṔosition.top + window.scrollY;
        }
        else {
            colorPickerPosition.top = wrapperṔosition.bottom + window.scrollY + 10;
            colorPickerPosition.left = window.innerWidth / 2 - colorPickerCardSize / 2;
        }
        store.dispatch('setColorPickerData', { position: colorPickerPosition, containerIdentifier: containerIdentifier, containerDiv: containerRelated });
    }
};
export const getIconBasedInMaterialType = (materialType, fileType, visibility, componentRendered) => {
    switch (materialType) {
        case 'task':
            return `<i style="font-size: 18px; color: ${visibility ? '#EE751C' : '#CCCCCC'}" class="bi ${componentRendered === 'materialItemCard' && ('fs-4')} bi-lightbulb"></i>`;
        case 'url':
            return `<i style="font-size: 18px; color: ${visibility ? '#457B9D' : '#CCCCCC'}" class="bi ${componentRendered === 'materialItemCard' && ('fs-4')} bi-link"></i>`;
        case 'quiz':
            return `<i style="font-size: 18px; color: ${visibility ? '#6A51DD' : '#CCCCCC'}" class="bi ${componentRendered === 'materialItemCard' && ('fs-4')} bi-card-checklist"></i>`;
        case 'iframe':
            return `<i style="font-size: 18px; color: ${visibility ? '#264653' : '#CCCCCC'}" class="bi ${componentRendered === 'materialItemCard' && ('fs-4')} bi-code-slash"></i>`;
        case 'file':
            switch (fileType) {
                case 'pdf':
                    return `<i style="font-size: 18px; color: ${visibility ? '#E63946' : '#CCCCCC'}" class="bi ${componentRendered === 'materialItemCard' && ('fs-4')} bi-file-pdf"></i>`;
                case 'docx':
                    return `<i style="font-size: 18px; color: ${visibility ? '#F4A261' : '#CCCCCC'}" class="bi ${componentRendered === 'materialItemCard' && ('fs-4')} bi-file-font"></i>`;
                case 'txt':
                    return `<i style="font-size: 18px; color: ${visibility ? '#F4A261' : '#CCCCCC'}" class="bi ${componentRendered === 'materialItemCard' && ('fs-4')} bi-file-font"></i>`;
            }
            break;
        case 'scorm':
            return `<i style="font-size: 18px; color: ${visibility ? '#BF8F1A' : '#CCCCCC'}" class="bi ${componentRendered === 'materialItemCard' && ('fs-4')} bi-puzzle"></i>`;
        case 'audio':
            return `<i style="font-size: 18px; color: ${visibility ? '#2A9D8F' : '#CCCCCC'}" class="bi ${componentRendered === 'materialItemCard' && ('fs-4')} bi-file-music"></i>`;
        case 'lti_tool':
            return `<i style="font-size: 18px; color: ${visibility ? '#3792E0' : '#CCCCCC'}" class="bi ${componentRendered === 'materialItemCard' && ('fs-4')} bi bi-boxes"></i>`;
    }
};
export const checkColorType = (colorInHex) => {
    const threshold = 128;
    const hex = colorInHex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    return luminance >= threshold;
};
// returnType pode ser tag ou texto
export const getQuestionTypeStyles = (questionType, returnType) => {
    switch (questionType) {
        case 'descriptive':
            return returnType === 'tag' ? `<p
                 style="white-space: nowrap; max-width: 100%; overflow: hidden; text-overflow: ellipsis ;color: #3580C1; border: 1px solid #3580C1"
                 class="w-auto px-2 py-1 rounded-3 mb-0">Descritiva</p>`
                : 'Descritiva';
        case 'choice':
            return returnType === 'tag' ? `<p
                style="white-space: nowrap; max-width: 100%; overflow: hidden; text-overflow: ellipsis;  color: #14AD30; border: 1px solid #14AD30"
                class="w-auto px-2 py-1 rounded-3 mb-0">Multipla Escolha</p>`
                : 'Multipla Escolha';
        case 'true-or-false':
            return returnType === 'tag' ? `<p
                style="white-space: nowrap; max-width: 100%; overflow: hidden; text-overflow: ellipsis; color: #F9A825; border: 1px solid #F9A825"
                class="w-auto px-2 py-1 rounded-3 mb-0">Verdadeiro ou Falso</p>`
                : 'Verdadeiro ou Falso';
    }
};
export const redirectUserToMainPageBasedInRole = () => {
    const userRole = store.getters.getType;
    const commumAccessRoles = ['student', 'tutor', 'teacher'];
    const managementAccessRoles = ['manager', 'supervisor', 'client'];
    commumAccessRoles.includes(userRole) && (router.push({ name: 'My Disciplines' }));
    managementAccessRoles.includes(userRole) && (router.push({ name: 'Disciplines' }));
    userRole === 'admin' && (router.push({ name: 'Home' }));
};
export const redirectToUserProfile = async (userId) => {
    if (!userId)
        return;
    await router.push({ name: 'Profile View', params: { id: userId } });
};
export const validateRestrictionData = (data) => {
    const contentManipulatedId = data?.disciplineId || data?.materialId || data?.materialItemId;
    const consumersId = data.consumers_ids;
    return {
        validPayload: Boolean((Array.isArray(consumersId) && consumersId.length > 0) && contentManipulatedId),
        contentManipulatedId: contentManipulatedId || null,
        consumersId: consumersId || []
    };
};
export const selectFitsInRightSide = (referenceElementRightPosition, selectMinimumWidth, referenceElementLeftPosition = 0) => {
    const userScreenSize = store.getters.getUserWidth;
    const acessibilityFontScale = store.getters['acessibility/fontMultiplier'];
    const gapFromBorder = 20;
    const selectWidth = selectMinimumWidth * acessibilityFontScale;
    const selectTotalWidth = selectWidth + gapFromBorder;
    return {
        fitsInRightSide: Boolean((referenceElementRightPosition + selectTotalWidth) < userScreenSize),
        fitsInLeftSide: Boolean((referenceElementLeftPosition - selectTotalWidth) > gapFromBorder),
        selectWidth: selectWidth
    };
};
export const getStarsRating = (rating, renderRating, alignCenter) => {
    const MAX_STARS = 5;
    const HALF_STAR_THRESHOLD = 0.5;
    const filledStars = Math.floor(rating);
    const decimalPart = rating - filledStars;
    const halfStars = decimalPart >= HALF_STAR_THRESHOLD ? 1 : 0;
    const emptyStars = MAX_STARS - (filledStars + halfStars);
    const filledHTML = '<i class="bi bi-star-fill"></i>'.repeat(filledStars);
    const halfHTML = halfStars > 0 ? '<i class="bi bi-star-half"></i>' : '';
    const emptyHTML = '<i class="bi bi-star"></i>'.repeat(emptyStars);
    return `<div class="w-100 ${alignCenter && ('justify-content-center')} d-flex p-0 m-0 gap-1">${filledHTML}${halfHTML}${emptyHTML} 
    <span class="p-0 m-0 opacity-0">*</span> ${renderRating ? rating.toFixed(1) : ''}
    </div>`;
};
export const getDisciplineStatusMesage = (disciplineRating, hasFeedbacks) => {
    return hasFeedbacks ? disciplineRating < 3 ? 'Crítica' : disciplineRating < 4 ? 'Atenção' : 'Regular' : 'Não avaliado';
};
export const getDisciplineStatusStyle = (disciplineRating, buttonStyle, hasFeedbacks) => {
    const statusColor = hasFeedbacks ? disciplineRating < 3 ? '#D70A0A' : disciplineRating < 4 ? '#FFAD47' : '#14AD30' : '#000000';
    return {
        ...buttonStyle && {
            borderRadius: '12px',
            padding: '0px 10px',
            border: `1px solid ${statusColor}`
        },
        color: statusColor,
    };
};
export const copyStringToClipboard = (string) => {
    if (!string)
        return store.dispatch('toastfy/activeErrorNotification', { text: "Ocorreu um erro ao copiar conteúdo! Tente novamente" });
    try {
        navigator.clipboard.writeText(string);
        store.dispatch('toastfy/activeSuccesNotification', { text: "Conteúdo copiado com sucesso!" });
    }
    catch {
        store.dispatch('toastfy/activeErrorNotification', { text: "Ocorreu um erro ao copiar conteúdo! Tente novamente" });
    }
};
export const downloadFileFromUrl = (url) => {
    if (!url)
        return;
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', '');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
export const FILE_ICON_MAP = {
    'jpg': 'bi-file-image',
    'jpeg': 'bi-file-image',
    'png': 'bi-file-image',
    'webp': 'bi-file-image',
    'gif': 'bi-file-image',
    'bmp': 'bi-file-image',
    'svg': 'bi-file-image',
    'mp3': 'bi-file-music',
    'wav': 'bi-file-music',
    'ogg': 'bi-file-music',
    'aac': 'bi-file-music',
    'flac': 'bi-file-music',
    'm4a': 'bi-file-music',
    'mp4': 'bi-file-play',
    'avi': 'bi-file-play',
    'mov': 'bi-file-play',
    'wmv': 'bi-file-play',
    'flv': 'bi-file-play',
    'webm': 'bi-file-play',
    'mkv': 'bi-file-play',
    'pdf': 'bi-file-pdf',
    'xls': 'bi-file-excel',
    'xlsx': 'bi-file-excel',
    'csv': 'bi-file-excel',
    'doc': 'bi-file-word',
    'docx': 'bi-file-word',
    'odt': 'bi-file-word',
    'ppt': 'bi-file-ppt',
    'pptx': 'bi-file-ppt',
    'zip': 'bi-file-zip',
    'rar': 'bi-file-zip',
    '7z': 'bi-file-zip',
    'txt': 'bi-file-text'
};
export const getFileExtension = (fileName) => {
    if (!fileName)
        return '';
    const extension = fileName.split('.').pop()?.toLowerCase() || '';
    return extension;
};
export const getFileIcon = (fileName) => {
    const extension = getFileExtension(fileName);
    return FILE_ICON_MAP[extension] || 'bi-file-earmark';
};
export const getFileName = (url) => {
    if (!url)
        return 'Arquivo';
    const parts = url.split('/');
    const fileNameWithTimestamp = parts[parts.length - 1];
    const match = fileNameWithTimestamp.match(/\d{4}-\d{2}-\d{2}T[\d:+-]+_(.+)$/);
    return match ? decodeURIComponent(match[1]) : decodeURIComponent(fileNameWithTimestamp);
};
export const isImageFile = (fileName) => {
    const extension = getFileExtension(fileName);
    return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(extension);
};
export const isVideoFile = (fileName) => {
    const extension = getFileExtension(fileName);
    return ['mp4', 'avi', 'mov', 'wmv', 'flv', 'webm', 'mkv'].includes(extension);
};
export const isAudioFile = (fileName) => {
    const extension = getFileExtension(fileName);
    return ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a'].includes(extension);
};
export const isDocumentFile = (fileName) => {
    if (!fileName)
        return false;
    return !isImageFile(fileName) && !isVideoFile(fileName) && !isAudioFile(fileName);
};
export const playNotificationSound = () => {
    const audio = new Audio(notificationAudio);
    audio.play().catch(() => { });
};
export const handleDisciplineFeedbackNavigation = (disciplineId, showToast = true) => {
    if (!disciplineId)
        return;
    const currentRoute = router.currentRoute.value;
    const alreadyOnPage = currentRoute.name === 'Discipline Material' && String(currentRoute.params.id) === String(disciplineId);
    if (!alreadyOnPage) {
        const resolved = router.resolve({ name: 'Discipline Material', params: { id: disciplineId }, query: { _md: 'df', ...(showToast && { _ts: 'df' }) } });
        window.location.href = resolved.href;
        return;
    }
    if (showToast) {
        store.dispatch('toastfy/activeSuccesNotification', { text: 'Avaliação de disciplina disponível!' });
    }
    setTimeout(() => {
        store.dispatch('setModalData', { modalName: 'AvaliateMaterialsModal', modalWrapperDiv: '.avaliate-materials-wrapper' });
    }, 0);
};
